export default "__VITE_ASSET__DI7D3lBf__"